import axios from 'axios';
import Cookies from 'js-cookie';

const wishList = {
  namespaced: true, // 모듈을 네임스페이스화
  state: {
    // 상태 정의
    // 위시리스트 
    wishlistData: [],
  },
  mutations: {
    // 뮤테이션 정의
    setWishlistData(state, data) {
      state.wishlistData = data;
    },
  },
  actions: {
    // 액션 정의
    async fetchWishlistData({ commit }) {
      try {

        let encodedCookie = await Cookies.get('memInfo');
        // let encodedCookie = '%7B%22memNo%22%3A%22216544%22%2C%22memId%22%3A%22childy_test%22%2C%22memNm%22%3A%22%5Cucc28%5Cuc77c%5Cub514%5Cud14c%5Cuc2a4%5Cud2b8%22%2C%22groupSno%22%3A%221%22%7D';
        // let encodedCookie = null;
        try {
          var decodeCookie = JSON.parse(decodeURIComponent(encodedCookie));
          var memNo = decodeCookie.memNo;
          const response = await axios.get(`https://service.childy.co.kr/api/common.php?url=goods%2Fgoods_wish.php&json_data={"mode":"getAllData","memNo":"${memNo}"}`);
          commit('setWishlistData', response.data);

        } catch (error) {
          // 오류가 발생한 경우 처리할 내용을 여기에 작성합니다.
          // console.log("Error fetching wishlist data:", error.message);
        }
      } catch (error) {
        console.error('Error fetching wishlist data:', error);
      }
    },
  },
  getters: {
    // 게터 정의
    wishlistData(state) {
      return state.wishlistData;
    },
  }
}

export default wishList;
